import { EquipeSelectModel } from 'components/form'
import { metaPath } from 'util/metaPath'
import { LotacaoSelectFieldModel } from 'view/profissional/lotacao/LotacaoSelectField'

export interface NovoAtendimentoFormModel {
  equipe?: EquipeSelectModel
  lotacao?: LotacaoSelectFieldModel
  tiposServico?: ID[]
  agendados?: ID[]
}

export const meta = metaPath<NovoAtendimentoFormModel>()
